import React, {useContext} from "react";
import {Button, Card, Form, Row, Tabs, Upload} from "antd";
import {API_BASE_URL, ASSET_BASE_URL} from "../../configs/AppConfig";
import {InboxOutlined, FileImageOutlined, DeleteOutlined} from "@ant-design/icons";
import {useSelector} from "react-redux";
import {LANGS} from "../../lang";
import SeoPanelFields from "./SeoPanelFields";
import MultiDevise, {ActiveDevise} from "./MultiDevise";
import OptionsCollapse from "./OptionsCollapse";


function formatFormChildren(children, lang) {
    let _children = [];

    React.Children.forEach(children, (child) => {

        if (React.isValidElement(child)) {
            const _props = {...child.props}
            let addToChildren=false


            switch (child.type) {
                case Form.Item:
                    if(child.props?.__langSupport)
                    {
                        addToChildren=true
                        _props.key = lang.value + "." + _props.name
                        _props.name = [lang.value, _props.name]
                        if (_props.label) {
                            _props.label = _props.label + " - (" + lang.label + ")"
                        }

                        if (_props.rules) {
                            _props.rules = _props.rules.filter(i => !i.required)
                        }
                    }
                    break;
                case SeoPanelFields:
                case ActiveDevise:
                    addToChildren=true
                    _props.lang = lang
                    break;
                default:
                    if (_props.children) {
                        _props.children = formatFormChildren(_props.children, lang)
                        if(React.Children.toArray(_props.children).length>0){
                            addToChildren=true
                        }
                    }
            }

            if(addToChildren){
                _children.push(React.cloneElement(child, _props))
            }
        }

        return child
    })

    return _children
}

function getChildren(children) {
    let _children = []
    React.Children.forEach(children, (child) => {
        if (React.isValidElement(child)) {
            const _props = {...child.props}

            if (child.props?.__langSupport || [SeoPanelFields].includes(child.type)) {
                _children.push(child)
            }

        }
    })

    console.log("_children",_children)
    return _children
}

const MultiLang = (props) => {

    let languages = useSelector(state => state.auth.org.languages) || []
    let language = useSelector(state => state.auth.org.language) || "fr"

    let functionalMainChildren=false
    let mainChildren = props.children
    if (typeof mainChildren === "function") {
        functionalMainChildren=true
        mainChildren=props.children(LANGS.find(i=>i.value === language))
    }

    if ((languages.length === 0 || props.disabled) && !functionalMainChildren) {
        return mainChildren
    }


    let mainLabel=LANGS.find(i=>i.value === language)?.label
    let tabs = [{key: language, label: mainLabel, children: mainChildren}]
    if(functionalMainChildren){
        tabs.splice(0,0,{key:"default",label:"Automatique",children:props.children(null)})
    }

    for (var l of languages) {
        const lang = LANGS.find(i => i.value === l)
        if (!lang) {
            continue
        }


        let children = null

        if (typeof props.children === "function") {
            children = props.children(lang)
        } else {
            children = formatFormChildren(props.children, lang)
        }

        tabs.push({key: l, label: lang.label, children: children})
    }

    return (
        <Tabs tabBarStyle={{marginTop: 0}} items={tabs}/>
    )
}


export default MultiLang
